module.exports = __webpack_public_path__ + "static/media/auditoriumP.d3f082d0.jpg";